import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button } from '@components/primitives/Button.js'

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl: string, registration: ServiceWorkerRegistration | undefined) {
      if (registration) {
        setInterval(() => registration.update(), 60 * 60 * 1000)
      }
    },
  })

  if (!needRefresh) return null

  return (
    <div className='cf3-update-prompt' role='status' aria-live='polite'>
      <p className='cf3-update-prompt__text'>Nova versão do app disponível.</p>
      <Button
        size='sm'
        variant='primary'
        onClick={() => updateServiceWorker(true)}
        aria-label='Atualizar aplicativo agora'
      >
        Atualizar
      </Button>
      <button
        type='button'
        className='cf3-update-prompt__dismiss'
        onClick={() => setNeedRefresh(false)}
        aria-label='Atualizar depois'
      >
        Depois
      </button>
    </div>
  )
}
